import axios from "axios";

export function approveHandoff(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `/consumer/admin/api/v1/item-replacement/handoff/${parameters.uuid}/approve`,
        {
          node_uuid: parameters.node_uuid,
        }
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
